module.exports = __webpack_public_path__ + "static/media/ball_1_2.6974637b.mp3";